import { z } from 'zod';
import { AuditSchema } from '../settings/audit-schema';

export const AcademyStudentSchema = z.object({
  ownerId: z.string(),
  studentUid: z.string(), // Firebase Auth UID
  primaryClientId: z.string().optional(),
  clientIds: z.array(z.string()).default([]),
  
  profile: z.object({
    name: z.string(),
    phone: z.string(),
    email: z.string().email().optional(),
    birthdate: z.string().optional(),
  }),

  // ARRAY MAESTRO: Aquí es donde prendemos y apagamos accesos
  authorizedCourses: z.array(z.string()).default([]),

  // Seguimiento de progreso centralizado
  progress: z.record(z.string(), z.object({
    completedLessons: z.array(z.string()).default([]),
    lastAccessedAt: z.any().optional(),
  })).default({}),

  audit: AuditSchema.optional(),
});

export type AcademyStudent = z.infer<typeof AcademyStudentSchema>;
export type AcademyStudentWithId = AcademyStudent & { id: string };
